import { Component, Inject } from '@angular/core';
import moment from 'moment';
import { MatIcon } from "@angular/material/icon";
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dp-1-orpt-filter',
  standalone: true,
  imports: [MatIcon, FormsModule],
  templateUrl: './dp-1-orpt-filter.component.html',
  styleUrl: './dp-1-orpt-filter.component.scss'
})
export class Dp1OrptFilterComponent {
  constructor(
    public dialogRef: MatDialogRef<Dp1OrptFilterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  today: string = moment().tz('Asia/Kolkata').format('YYYY-MM-DD');
  startDate: string = moment().tz('Asia/Kolkata').startOf('month').format('YYYY-MM-DD');
  endDate: string = '';
  apiData: any = []

  ngOnInit(): void {
    this.startDate = this.data.startDate;
    this.endDate = this.data.endDate;
    console.log(this.startDate, 'the dialog data');

  }

  closeDialog() {
    this.dialogRef.close({});
  }
  clearData() {
    this.startDate = ''
    this.endDate = ''
  }

  searchForData() {
    const object = {
      startDate: this.startDate ?? '',
      endDate: this.endDate ?? ''
    }
    console.log(object)
    this.dialogRef.close(object)
  }


}
